module.exports = __webpack_public_path__ + "img/quan-bg.e710a950.png";